<template>
    <div id="">
        <!-- CONTAINER DE ALERTAS -->
        <alert-container :messages="msgs"/>
        <!-- Botão de Salvar -->
        <div class="listing-header mb-4">
            <div class="title-breadcrumb"></div>
                <div class="header-buttons">
                    <button
                        v-if="
                            ((!isUpdate && permissao.create) ||
                                (isUpdate && permissao.update)) &&
                            !grupoIntegracao
                        "
                        class="save-btn"
                        type="button"
                        @click="save()"
                        :disabled="isSaving"
                    >
                        {{ $t("salvar") }}
                        <button-loader :isSaving="isSaving" />
                    </button>
                </div>
        </div>
        <div class="page page-container">
            <div class="form-columns-fit">
                <div class="columns is-flex-wrap">
                    <div class="column is-6">
                        <v-input 
                            :id="generateId(1)"
                            ref="idErpInput"
                            v-model="centroCusto.idfin_centro_custoerp"
                            placeholder="placeholder-preencha"
                            :maxlength="30"
                            title="codigo"
                            uppercase
                            required
                            tooltipLabel="cod-ref"
                            :invalid="!centroCusto.idfin_centro_custoerp"
                            :disabled="grupoIntegracao || isLoading"
                        />
                    </div>
                    <div class="column is-6">
                        <v-input
                            v-model="centroCusto.descricao"
                            :id="generateId(2)"
                            :placeholder="'descricao'"
                            :maxlength="250"
                            title="descricao"
                            msg="msg-campo-obrigatorio"
                            :invalid="!centroCusto.descricao"
                            ref="descricaoInput"
                            required
                            :disabled="grupoIntegracao || isLoading"
                        />
                    </div>
                    <div class="column is-6">
                        <vss-select
                            :id="generateId(4)"
                            v-model="situacaoSelected"
                            title="situacao"
                            :required="true"
                            :options="situacaoSelect"
                            mlLabels
                            :searchable="false"
                            :disabled="!isUpdate || grupoIntegracao || isLoading"
                            tooltipLabel="info-situacao-generica"
                        />
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import CentroCustoService from "@/services/vendas/financeiro/CentroCustoService.js";
import CentroCustoValidation from "@/services/validations/financeiro/CentroCustoValidation.js";
import Message from "@/models/Message";

export default {
    data() {
        return {
            grupoIntegracao:
                this.$store.state.user.tabelasERPWebServer.includes("FIN_CENTRO_CUSTO"),
            service: new CentroCustoService(this.$http, this.$router),
            validation: new CentroCustoValidation(this.msgs),
            isSaving: false,
            centroCusto: {
                idfin_centro_custo: '',
                idfin_centro_custoerp: '',
                descricao: '',
                situacao: 1,
            },
            msgs: [],

            situacaoSelected: { label: "ativo", id: 1 },
            situacaoSelect: [
                { label: "inativo", id: 0 },
                { label: "ativo", id: 1 },
            ],
            isUpdate: false,
            isLoading: false,
        };
    },
    created() {
        if (this.$route.meta.contexto == "vendas") {
            this.permissao = this.hasPermissionAccess(
                "vendas",
                "financeiro",
                "ven-centro-custo"
            );
        } else if (this.$route.meta.contexto == "despesas") {
            this.permissao = this.hasPermissionAccess(
                "despesas",
                "cadastros",
                "des-centro-custo"
            );
        }

        if (!this.permissao.read) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "centro-custo" },
            });
        } else {
            if (this.$route.params.id) this.isUpdate = true;
            
            if (!this.isUpdate && !this.permissao.create) {
                this.$router.push({
                    name: "acesso-nao-permitido",
                    params: { tela: "centro-custo" },
                });
            }

            if (this.$route.params.id) {
                this.carregarDados(this.$route.params.id);
            }
        }
    },
    methods: {
        generateId(numberId){
            return this.$route.name+'-'+numberId;
        },
        carregarDados(id) {
            this.isLoading = true;
            this.service
                .find(id)
                .then((body) => {
                    this.centroCusto = Object.assign(body.content);
                    this.situacaoSelected = this.situacaoSelect 
                        ? this.situacaoSelect.find((s) => s.id == this.centroCusto.situacao)
                        : situacaoSelected;
                    this.$emit('descricao', this.centroCusto.descricao);
                })
                .catch((e) => {
                    let msg = this.$t("msg-erro-carregar-n", { n: this.$t("centro-custo") });
                    this.msgs.push(
                        new Message("error", msg, true, false)
                    );
                })
                .finally((_) => {
                    this.isLoading = false;
                });
        },
        save() {
            this.isLoading = true;

            if (this.validation.validate(this.centroCusto, this.$refs)) {
                let centroCustoTemp = Object.assign({}, this.centroCusto);
                centroCustoTemp = this.mapTosave(centroCustoTemp);
                centroCustoTemp.situacao = this.situacaoSelected.id;

                this.isSaving = true;
                this.service
                    .save(centroCustoTemp)
                    .then((r) => {
                        let msg = this.$t(
                                this.centroCusto.id != null
                                    ? "msg-edit-sucesso-n"
                                    : "msg-save-sucesso-n", 
                                { n: this.$t("centro-custo") }
                            );
                        this.msgs.push(
                            new Message("success", msg, true, false)
                        );
                        this.redirectToList();
                    })
                    .catch((e) => {
                        let message = e.body.message;
                        if (message && this.$te(message)) {
                            if (message == 'msg-codigo-duplicado-n') {
                                this.msgs.push(
                                    new Message(
                                        "alert",  
                                        this.$t(message, { n: centroCustoTemp.idfin_centro_custoerp }), 
                                        true, 
                                        false
                                ));
                            } else if (message == 'msg-descricao-duplicada-n') {
                                this.msgs.push(
                                    new Message("alert", 
                                    this.$t(message, { n: centroCustoTemp.descricao }), 
                                    true, 
                                    false
                                ));
                            } else {
                                let msgErro = this.$t(e);
                                this.msgs.push(
                                    new Message("alert", msgErro, true, false)
                                );
                            }
                        } else {
                            this.msgs.push(
                                new Message(
                                    "error",
                                    "msg-problema-realizar-acao",
                                    true,
                                    false
                                )
                            );
                        }
                    })
                    .finally((_) => {
                        this.isLoading = false;
                        this.isSaving = false;
                    });
            } else {
                this.msgs.push(
                    new Message(
                        "alert",
                        "msg-campos-obrigatorios",
                        true
                    )
                );
                this.isLoading = false;
            }
        },
        redirectToList() {
            setTimeout(() => {
                this.$router.push({
                    name: `${this.$route.meta.abrev}-centro-custo-list`,
                });
            }, 2000);
        },
    },
};
</script>

<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: auto;
}
.page {
    position: relative;
    padding: 20px 20px;
    background-color: $sovis-white;
    box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);
    border-radius: 2px;
    margin-bottom: 80px;
    height: auto;
}
</style>
